import React, { createContext, useContext } from "react";
import Api from "./Api";
const ApiContext = createContext();

export default function ApiProvider({ children }) {
  const api = new Api();
  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;
}

export function useApi() {
  return useContext(ApiContext);
}
